<template>
    <div>
        <div style="padding-bottom: 11px; padding-top: 11px;">
            <div class="list-item-skeleton-root px-5 py-5 skeleton-loading">
                <div class="square" />
            </div>
        </div>
        <Divider />
    </div>
</template>

<script>
export default {
    name: 'AvailabilityViewerSkeleton',
    props: {
        rows: {
            type: Number,
            default: 4,
        },
        mini: {
            type: Boolean,
            default: false,
        },
        small: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style scoped>
.list-item-skeleton-root {
    display: flex;
}
.column-item {
    flex-grow: 1;
    margin: 0 10px;
}
.square {
    margin: 20px 10px;
    width: 100%;
    height: 400px;
    background-color: rgb(230, 230, 230);
    border-radius: 4px;
}
.squareSmall {
    width: 70px;
    height: 70px;
}
.squareMini {
    width: 50px;
    height: 50px;
}
.row-item {
    flex-grow: 1;
    margin-top: 10px;
    margin-bottom: 10px;
    height: 16px;
    width: 100%;
    background-color: rgb(230, 230, 230);
    border-radius: 3px;
}
</style>

<style>
.skeleton-loading {
    position: relative;
    overflow: hidden;
}

.skeleton-loading::after {
    display: block;
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    transform: translateX(-100%);

    background: linear-gradient(
        90deg,
        transparent,
        rgba(255, 255, 255, 0.45),
        transparent
    );
    animation: skeleton-loading 1.4s infinite;
}

@keyframes skeleton-loading {
    100% {
        transform: translateX(100%);
    }
}
</style>
